import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayPolygon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11,
	height: 11,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-play",
	...props,
	children: /* @__PURE__ */ _jsx("polygon", { points: "6 3 20 12 6 21 6 3" })
});
export default SvgPlayPolygon;
